import { IconButton } from '@cad-arc';
import {
    ExpandablePanelSize,
    ExpandablePanelType,
    useExpandablePanelSize,
    useSetExpandablePanelSize,
} from '../expandable-panel-size';

export const EntityPanelHeaderResizeButtons = ({
    isXXLEnabled,
    panelType,
}: {
    isXXLEnabled: boolean;
    panelType: ExpandablePanelType;
}) => {
    const setExpandablePanelSize = useSetExpandablePanelSize();
    const expandablePanelSize = useExpandablePanelSize();
    const getItemTestId = (item: ExpandablePanelSize) =>
        `${panelType.toLowerCase()}-panel-size-${item}-button`;

    return (
        <>
            <IconButton
                isActive={expandablePanelSize === 'NORMAL'}
                variant="ghost"
                aria-label="normal"
                icon="VerifiedLocation"
                onClick={() => {
                    setExpandablePanelSize('NORMAL');
                }}
                data-testid={getItemTestId('NORMAL')}
            />
            <IconButton
                isActive={expandablePanelSize === 'XL'}
                variant="ghost"
                aria-label="xl"
                icon="LayoutTwoColumns"
                onClick={() => {
                    setExpandablePanelSize('XL');
                }}
                data-testid={getItemTestId('XL')}
            />
            <IconButton
                isActive={expandablePanelSize === 'XXL'}
                variant="ghost"
                aria-label="xxl"
                icon="LayoutThreeColumns"
                isDisabled={!isXXLEnabled}
                onClick={() => {
                    setExpandablePanelSize('XXL');
                }}
                data-testid={getItemTestId('XXL')}
            />
        </>
    );
};
